import React, { FunctionComponent } from "react";

const NotFound: FunctionComponent = () => {
	return (
		<h1 className="d-flex justify-content-center">Not found</h1>
	);
};

export default NotFound;
